import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModalService, BaseUpdateComponent, QueryParameter, ModelDataService, DefgIniService, CompanyDataService, CompanyData, ConfirmationDialogButtons, ModelData, ModalSize, ErrorHandlerService, UserRightsService, TableContextMenuItem, NotificationService, LoaderService } from 'yt-ng-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { List } from 'immutable';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { query, transition } from '@angular/animations';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { PoljaZaVelikeLanceComponent } from './polja-za-velike-lance/polja-za-velike-lance.component';
import { ViewChild } from '@angular/core';
import { GabaritiRobeComponent } from './gabariti-robe/gabariti-robe.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TransporteriComponent } from './transporteri/transporteri.component';

import { FakDokument } from './fak-dokument';
import { FakDokumentView } from './fak-dokument-view';
import { FakDokumentService } from './fak-dokument-service';
import { FakDokumentUpdateComponent } from './fak-dokument-update.component';
import { FakDokumentTabsComponent } from './fak-dokument-tabs.component';


@Component({
  selector: "yt-fak-dokument-tab-update",
  templateUrl: "./fak-dokument-tab-update.component.html",
})
export class FakDokumentTabUpdateComponent
  extends BaseTabsUpdateComponent<FakDokument>
  implements OnInit
{
  formControlDataName: string;
  efaktureTaster: number;
  ShowEUInvoice: boolean = false;
  // ShowSendEUInvoice: boolean = false;
  loadingSendEUInvoice: boolean = false;
  loadingEUInvoiceInXml: boolean = false;
  loadingEUInvoiceStatus: boolean = false;
  loadingReciveEUInvoice: boolean = false;
  bojaStatusa = "transparent";
  hasUserRightsOdabirDokumenta: boolean;
  hasUserRightsOdabirAvansa: boolean;
  hasUserRightsVezaSaDodatnimDokumentima: boolean;
  hasUserRightsDodatnaPolja: boolean;
  hasUserRightsOdabirRacuna: boolean;
  hasUserRightsTransporteri: boolean;
  actionService: any;
  
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<FakDokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected router: Router,
    protected defgIni: DefgIniService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected companyDataService: CompanyDataService,
    // protected notificationsService: NotificationsService,
    protected errorService: ErrorHandlerService,
    protected userRightsService: UserRightsService,
    private fakDokumentService: FakDokumentService,
    loaderService?: LoaderService,
    changeDetectorRef?: ChangeDetectorRef

  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  @ViewChild('baseUpdate', { static: true }) fakBaseUpdate: FakDokumentUpdateComponent;

  hasUserRightsPrintDispatch: boolean;
  ngOnInit() {
    super.ngOnInit();

    this.fakDokumentService.baseUpdateComponent = this.fakBaseUpdate;

    this.ContextMenuSettings();


    this.hasUserRightsPrintDispatch = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"PrintDispatch")
    this.formControlDataName =
      this.modelData["MainList"]["FormControlDataName"];
    this.efaktureTaster = this.defgIni.GetByKey("g_efakture_taster");
    this.ShowEUInvoice =
      (this.efaktureTaster == 1 || this.efaktureTaster == 3) &&
      this.formControlDataName != "fak/izvozniracun";
    // this.ShowSendEUInvoice =
    //   (this.efaktureTaster == 2 || this.efaktureTaster == 3) &&
    //   this.formControlDataName != "fak/izvozniracun";

    this.baseUpdateComponent.ItemLoaded.subscribe(()=>{
      // this.RefreshStatusEUInvoice(this.baseUpdateComponent.Item.ID);
    })

    this.baseUpdateComponent.IDProcessed.subscribe((value) => {
      if (value && this.baseUpdateComponent.Item.ID > 0){
        this.bojaStatusa = this.baseUpdateComponent.Item.StatusColor;
        // this.RefreshStatusEUInvoice(this.baseUpdateComponent.Item.ID);
        // console.log(value);
        this.baseDataService.Get("FakDokument", "GetViewItemByID", [ new QueryParameter("id",  this.baseUpdateComponent.Item.ID)], FakDokumentView )
        .subscribe((data: any) => {
          if(data){
            let fakDokumentView: FakDokumentView = data;
            this.VezanZaPpp = fakDokumentView.VezanZaPpp;
          }

        })}
      else
        // 18.1.2023
        this.bojaStatusa = "transparent";
    });

    this.baseUpdateComponent.ItemSaved.subscribe((value) => {
      if (value && this.baseUpdateComponent.Item.ID <= 0)
        this.RefreshStatusEUInvoice(this.baseUpdateComponent.Item.ID);
    });

    this.hasUserRightsOdabirDokumenta = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"odabirDokumenta");
    this.hasUserRightsOdabirAvansa = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"odabirAvansa");
    this.hasUserRightsVezaSaDodatnimDokumentima = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"vezaSaDrugimDokumentima");
    this.hasUserRightsDodatnaPolja = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"dodatnaPolja");
    this.hasUserRightsOdabirRacuna = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"odabirRacuna");
    this.hasUserRightsTransporteri = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName, "transport")


    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.ItemSaved.subscribe((value)=>{
      if (value){
        let idParameter = [new QueryParameter("id", this.baseUpdateComponent.Item.ID)];
        this.baseDataService.Get(this.baseUpdateComponent.modelData.MainList.ModelName,
           "GetViewItemByID",
           idParameter,
            this.baseUpdateComponent.modelData.MainList.ShortModelClass)
           .subscribe((data:any)=>{
              // ovo utiče na osvežavanje tabele za dokumenta na pregledu. Osvežava MainItems
              this.tabsContainerService.EmitItem(data);
           })
      }
    })

  }


  UcitajAvanse() {
    if (this.baseUpdateComponent.baseFormGroup.invalid) {
      this.baseUpdateComponent.SaveItem();
      return;
  }

    this.fakDokumentService.checkUnsavedChanges(
      () => this.fakDokumentService.UcitajAvanse()
    );
  }
  


  UcitajGabariteRobe() {
    if (this.baseUpdateComponent.baseFormGroup.invalid) {
      this.baseUpdateComponent.SaveItem();
      return;
  }

    this.fakDokumentService.checkUnsavedChanges(
      () => this.fakDokumentService.transport()
    );
  }



  // UcitajTransportere(){
  //   let modelData = new ModelData(null);
  //   modelData.ModalSize = ModalSize.Md;
  //   modelData.UpdateComponent = TransporteriComponent;

  //   let pozicija: string = this.baseUpdateComponent.baseFormGroup.get('Pozicija').value;
  //   let pozicijaParameter = new QueryParameter('Pozicija', pozicija);
  //   let crm: string = this.baseUpdateComponent.baseFormGroup.get('Crm').value;
  //   let crmParameter = new QueryParameter('Crm', crm);
  //   let vozilaIds: string = this.baseUpdateComponent.baseFormGroup.get('VozilaIds').value;
  //   let vozilaIdsParameter = new QueryParameter('VozilaIds', vozilaIds);
  //   let vozac: string = this.baseUpdateComponent.baseFormGroup.get('Vozac').value;
  //   let vozacParameter = new QueryParameter('Vozac', vozac);
  //   let napomenaTransporteri: string = this.baseUpdateComponent.baseFormGroup.get('NapomenaTransporteri').value;
  //   let napomenaTransporteriParameter = new QueryParameter('NapomenaTransporteri', napomenaTransporteri);
  //   let id: number = this.baseUpdateComponent.Item.ID;
  //   let idParameter = new QueryParameter('ID', id);

  //   let disabledFormParameter = new QueryParameter('DisabledForm', this.baseUpdateComponent.baseFormGroup.disabled);

  //   if(modelData){
  //     this.modalService.ShowModal(0, modelData, null, true, [
  //       pozicijaParameter,
  //       crmParameter,
  //       vozilaIdsParameter,
  //       vozacParameter,
  //       napomenaTransporteriParameter,
  //       idParameter,
  //       disabledFormParameter
  //     ])
  //     .result.then( result => {
  //       this.fakBaseUpdate.SetPoljaZaTransportere = result;
  //     },
  //     () =>{})
  //   }
  // }

  async LoadItem(id: number) {
    await new Promise<void>((resolve, reject) => {
      this.baseUpdateComponent.Load(id);
      resolve();
    });
  }

  // OdaberiDokument(){

  //   let _modelData = this.modelDataService.GetModelDataByPath("odabirdokumenta");
  //   // let url = this.activatedRoute.url.value[0]["path"];
  //   let _url = this.router.url;
  //   let urlParameter = new QueryParameter("url",_url);
  //   if (_modelData){
  //       this.modalService.ShowModal(0,_modelData,null,true,[urlParameter])
  //           .result
  //           .then((item)=>{

  //           }, (reason) => {

  //           })

  //   }

  // }

  OdaberiDokumenta() {
    let _modelData =
      this.modelDataService.GetModelDataByPath("odabirdokumenata");
    let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    let idParameter = new QueryParameter("fakDokumentID", id);
    let _url = this.router.url;
    let urlParameter = new QueryParameter("url", _url);
    let master_id: number =
      this.baseUpdateComponent.baseFormGroup.get("MasterDokumID").value;
    let masterIDParameter = new QueryParameter("masterDokumID", master_id);
    let objekat_id: number =
      this.baseUpdateComponent.baseFormGroup.get("KomitentObjekatID").value;
    let objekatIDParameter = new QueryParameter("objekatID", objekat_id);

    let brojStavki: number =
      this.baseUpdateComponent.baseInlineContainer["tempItems"].size;
    let brojStavkiParameter = new QueryParameter("BrojStavki", brojStavki);
    let isLocked: boolean = this.baseUpdateComponent.baseFormGroup.get("Useridlk").value != null;
    let isLockedParameter = new QueryParameter("isLocked", isLocked);
    if (_modelData) {
      this.modalService
        .ShowModal(0, _modelData, null, true, [
          idParameter,
          urlParameter,
          masterIDParameter,
          objekatIDParameter,
          isLockedParameter
        ])
        .result.then(
          (item) => {
            this.LoadItem(id); //ubačeno da ponovo učita FakDokument, trebalo jer kod KO/KZ kada se povezuje sa računom, ne učita novi broj povezanih dokumenata UkBrPovezanihDokumenata
            this.baseUpdateComponent.baseInlineContainer.baseDetailList.RefreshData();
          },
          (reason) => {}
        );
    }
  }

  Iskoriscen() {
    let _modelData = this.modelDataService.GetModelDataByPath(
      "iskoriscen-dokument"
    );
    let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    let idParameter = new QueryParameter("fakDokumentID", id);
    if (_modelData) {
      this.modalService
        .ShowModal(0, _modelData, null, true, [idParameter])
        .result.then(
          (item) => {},
          (reason) => {}
        );
    }
  }

  EUInvoice(item : FakDokument) {
    let nastaviSlanje: boolean = true;

    if (!this.baseUpdateComponent.canDeactivate())
    {
      if (confirm('Dokument nije sačuvan. Sačuvaj i pošalji?')) {
        this.baseUpdateComponent.SaveItem();
        if (!(this.baseUpdateComponent.baseInlineContainer && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent
          && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()))
          this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
          item = this.baseUpdateComponent.Item;
          nastaviSlanje = true;
        }
        else {
          nastaviSlanje = false;
      }

    }
    if (nastaviSlanje && (this.baseUpdateComponent.baseFormGroup.valid || this.baseUpdateComponent.baseFormGroup.disabled)){

    let _id: Number = item.ID;
    // let fakDokumentIDQP = new QueryParameter("fakdokumentID", _id);

    // this.baseDataService.Get('FakDokument', 'EUInvoice', [new QueryParameter('fakdokumentID', _id)], null)
    //   .subscribe();
    let genericName : string = null;

    //if (This.podvrstaDokumentaGn)
      let _genericName = this.baseUpdateComponent.baseFormGroup.get('GenericName').value ;
      if (_genericName == 'ko' || _genericName == 'kz'){
        let _brojPovezanihDokumenata : Number = item.UkBrPovezanihDokumenata;
        let _datumOd : Date = item.DatumPrometaOd ? new Date(item.DatumPrometaOd["year"], item.DatumPrometaOd["month"]-1, item.DatumPrometaOd["day"]) : null;
        let _datumDo : Date = item.DatumPrometaDo ? new Date(item.DatumPrometaDo["year"], item.DatumPrometaDo["month"]-1, item.DatumPrometaDo["day"]) : null;

        if ((_brojPovezanihDokumenata == 0 && _datumOd == null && _datumDo == null) ||
            (_brojPovezanihDokumenata == 0 && (_datumOd != null && _datumDo == null)) ||
            (_brojPovezanihDokumenata == 0 && (_datumOd == null && _datumDo != null)) ||
            ((_brojPovezanihDokumenata != 0 && (_datumOd != null && _datumDo == null)) ||
            (_brojPovezanihDokumenata != 0 && (_datumOd == null &&_datumDo != null)) ||
            (_brojPovezanihDokumenata != 0 && _datumOd != null && _datumDo != null))
            ){

          this.translateService.get(["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"])
          .subscribe(translate => {
            this.modalService.ShowConfirmationDialog(
              _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"]
              , _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"]
              ,'warning',ConfirmationDialogButtons.Ok);
          });
          return false;
        }

      }

    let parameters = { fakdokumentID: _id, genericName: _genericName, brojDecimala: this.baseUpdateComponent["brojDecimala"]}; //genericName
    this.loadingEUInvoiceInXml = true;
    this.baseDataService
      .GetFile("FakDokument", "EUInvoice", parameters)
      .subscribe((result: any) => {
        this.loadingEUInvoiceInXml = false;
        var lcType = result.type;
        let fileUrl: string = URL.createObjectURL(result);
        if (lcType == "application/xml; charset=utf-8") {
          // window.open(fileUrl);
          var link = document.createElement("a");
          link.download = item.BrojDokumenta + ".xml";
          link.href = fileUrl;
          link.click();
        } else window.open(fileUrl);
      }
      ,error =>{
        this.loadingEUInvoiceInXml = false;
          // throw error;
          let _message;
          let translatedMessage: string = "";
          if(error instanceof HttpErrorResponse){
            _message = this.errorService.getServerMessage(error);
            if (_message instanceof ArrayBuffer){
              _message = String.fromCharCode.apply(null, new Uint8Array(_message));
              let message: string = _message;
              if (message.includes("EDOKUMENT")){
                let messageArray: string[] = message.split(';');
                messageArray.forEach((element, index) => {
                  messageArray[index] = "FW.ERRORS." + element;
                });
                this.translateService.get(messageArray)
                .subscribe(translate => {
                  translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                });
              }
              else
                translatedMessage = message;
            }
            else{
              translatedMessage = this.errorService.getClientMessage(error);
            }
          }
               this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

      });
    }
  }

  public VezanZaPpp = false;

  SendEUInvoice(item: FakDokument) {
    if (!this.baseUpdateComponent.canDeactivate()) {
        this.modalService.ShowConfirmationDialog(
            "Obaveštenje",
            "Dokument nije sačuvan. Sačuvaj i pošalji?",
            "question",
            ConfirmationDialogButtons.ConfirmCancel
        ).result.then((result) => {
            if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                this.baseUpdateComponent.SaveItem();
                if (!(this.baseUpdateComponent.baseInlineContainer &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate())) {
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                }
                item = this.baseUpdateComponent.Item;
                
                this.StartSendingProcess(item);
            }
        }).catch(() => {
            return;
        });
        return; 
    }

    this.StartSendingProcess(item);
}

    private StartSendingProcess(item: FakDokument) {
    if (this.baseUpdateComponent.baseFormGroup.valid) {
        let _id: Number = item.ID;
        let _masterDokumID: Number = item.MasterDokumID;
        let _today: Date = new Date();
        let _datum: Date = new Date(item.Datum["year"], item.Datum["month"] - 1, item.Datum["day"]);
        let _genericName = item.GenericName;
        let _brojDecimala = item.BrojDecimala;

        if (new Date(_datum.toLocaleDateString()) < new Date(_today.toLocaleDateString())) {
            this.translateService.get(["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"])
                .subscribe(translate => {
                    // this.notificationService.warn(translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]);
                    this.toastrService.warning(translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]);
                });
            return false;
        }

        if (_genericName == 'ko' || _genericName == 'kz') {
            let _brojPovezanihDokumenata: Number = item.UkBrPovezanihDokumenata;
            let _datumOd: Date = item.DatumPrometaOd ? new Date(item.DatumPrometaOd["year"], item.DatumPrometaOd["month"] - 1, item.DatumPrometaOd["day"]) : null;
            let _datumDo: Date = item.DatumPrometaDo ? new Date(item.DatumPrometaDo["year"], item.DatumPrometaDo["month"] - 1, item.DatumPrometaDo["day"]) : null;

            if ((_brojPovezanihDokumenata == 0 && _datumOd == null && _datumDo == null) ||
                (_brojPovezanihDokumenata == 0 && (_datumOd != null && _datumDo == null)) ||
                (_brojPovezanihDokumenata == 0 && (_datumOd == null && _datumDo != null)) ||
                ((_brojPovezanihDokumenata != 0 && (_datumOd != null && _datumDo == null)) ||
                (_brojPovezanihDokumenata != 0 && (_datumOd == null && _datumDo != null)) ||
                (_brojPovezanihDokumenata != 0 && _datumOd != null && _datumDo != null))) {

                this.translateService.get(["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV","EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"])
                  .subscribe(translate => {
                    this.modalService.ShowConfirmationDialog(
                      _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.NASLOV"]
                      , _genericName == 'ko' ? translate["EDOKUMENT.KO.MORABITIPOVEZANILIDATUMPROMETA.OPIS"] : translate["EDOKUMENT.KZ.MORABITIPOVEZANILIDATUMPROMETA.OPIS"]
                      ,'warning',ConfirmationDialogButtons.Ok);
                  });
                return false;
            }
        }

        if (Number(_brojDecimala) > 4) {
            this.translateService.get(["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"])
                .subscribe(translate => {
                    // this.notificationService.warn(translate["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"]);
                    this.toastrService.warning(translate["EDOKUMENT.CENA.MAXNUMBEROFDECIMALPLACEMORETHENINSEF"]);
                });
            return false;
        } else {
            var parameters1 = [];
            var parameter = new QueryParameter();
            parameter.Name = 'masterDokumID';
            parameter.Value = _masterDokumID.toString();
            parameters1.push(parameter);

            this.baseDataService.Get('FakDokument', 'GetDocStatusGenericName', parameters1, null).subscribe(data => {
                let salji = true;

                this.baseDataService.Get('FakDokument', 'GetDocStatusNaziv', [new QueryParameter('genericName', data.toString())], null).subscribe(dataNaziv => {
                    if (data && data.toString().toLowerCase() != "unknown" &&
                        ((data.toString().toLowerCase() == "sent" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta", "Dokument je već poslat na portal.", 'warning', ConfirmationDialogButtons.Ok)) ||
                        (data.toString().toLowerCase() == "delivered" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta", "Dokument je već isporučen.", 'warning', ConfirmationDialogButtons.Ok)) ||
                        confirm("Status računa je " + dataNaziv.toString() + " da li zaista želite da ga pošaljete na portal?") == false)) {
                        salji = false;
                    }
                    if (salji) {
                        let _modelData = this.modelDataService.GetModelDataByPath("send-edokument");
                        let idParameter = new QueryParameter("fakdokumentID", _id);
                        let masterIdParameter = new QueryParameter("masterDokumID", _masterDokumID);
                        let genericNameParameter = new QueryParameter("genericName", _genericName);
                        let brojDecimalaParameter = new QueryParameter("brojDecimala", this.baseUpdateComponent["brojDecimala"]);

                        if (_modelData) {
                            this.modalService.ShowModal(0, _modelData, null, true, [idParameter, masterIdParameter, genericNameParameter, brojDecimalaParameter]).result.then((item) => {
                                this.baseUpdateComponent.Item.OsvezivogStatusa = true;
                                this.RefreshStatusClick();
                            }, (reason) => {
                            });
                        }
                    }
                });
            });
        }
    }
  }



  ReciveEUInvoice(item: FakDokument) {
    let _id: Number = item.ID;
    let _masterDokumID: Number = item.MasterDokumID;

    let parameters = { fakdokumentID: _id, masterDokumID: _masterDokumID };
    this.loadingReciveEUInvoice = true;
    this.baseDataService
      .GetFile("FakDokument", "ReciveEUInvoice", parameters)
      .subscribe((result: any) => {
        this.loadingReciveEUInvoice = false;
        var lcType = result.type;
        let fileUrl: string = URL.createObjectURL(result);
        if (lcType == "application/xml; charset=utf-8") {
          // window.open(fileUrl);
          var link = document.createElement("a");
          link.download = item.BrojDokumenta + ".xml";
          link.href = fileUrl;
          link.click();
        } else window.open(fileUrl);
      });
  }

  uStatusuOtkljucavanja: boolean = false;

  RefreshStatusEUInvoice(id: number) {
    if (id > 0) {
      if (this.formControlDataName != "fak/izvozniracun" && this.formControlDataName != "fak/ponuda") {
        this.loadingEUInvoiceStatus = true;
        let idParameter = [new QueryParameter("id", id)];
        if (this.baseUpdateComponent.Item.OsvezivogStatusa) {
          // this.loadingEUInvoiceStatus = true;
          // let idParameter = [new QueryParameter("id", id)];
          this.baseDataService
            .Get("FakDokument", "OsveziStatus", idParameter, FakDokumentView)
            .subscribe((data: FakDokumentView[]) => {
              if (data != null && data.length > 0)
                this.bojaStatusa = data[0].StatusColor;
              else this.bojaStatusa = "transparent";

              this.baseDataService.GetByID("FakDokument",id,FakDokument)
              .subscribe((data: FakDokument) => {
                if (data)
                  this.baseUpdateComponent.Item = data;
                this.baseUpdateComponent.ItemLoaded.emit(this.baseUpdateComponent.Item);
              })

              // this.loadingEUInvoiceStatus = false;
            }
            ,error => {
              // this.loadingEUInvoiceStatus = false;
              throw error;
            }
            );
        } else {
          this.baseDataService
            .Get("FakDokument", "GetViewItemByID", idParameter, FakDokumentView)
            .subscribe((data:any) => {
              if (data != null && data.StatusColor!=null)
                this.bojaStatusa = data.StatusColor;
              else this.bojaStatusa = "transparent";
              // this.loadingEUInvoiceStatus = false;
            }
            ,error => {
              // this.loadingEUInvoiceStatus = false;
              throw error;
            }
            );
          if (this.baseUpdateComponent.Item.ProvajderID)
            // window.alert(
            //   "Dokumentu se ne može osvežiti status, ili nije podignut na SEF ili ste korisnik koji na to nema prava ili je dokument podignut na SEF preko drugog provajdera."
            // );
            this.translateService.get('EDOKUMENT.STATUS.NEMOZEDAOSVEZI')
            .subscribe(translate => {
              window.alert(translate);
            })
        }
        this.loadingEUInvoiceStatus = false;
      }
    }
  }

  RefreshStatusClick() {
    this.RefreshStatusEUInvoice(this.baseUpdateComponent.Item.ID);
  }

ContextMenuSettings() {
    if (this.defaultUpdateButtons) {
          this.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Visible = true;
        this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
        this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
        
      if (!this.actionService) {
        this.actionService = this.fakDokumentService;
      }
  
      if (!this.actionService.baseUpdateComponent) {
          this.actionService.baseUpdateComponent = this.baseUpdateComponent;
      }
      
        if (this.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Visible) {
          
            const originalToggleContextMenu = this.defaultUpdateButtons.ToggleContextMenu.bind(this.defaultUpdateButtons);

            this.defaultUpdateButtons.ToggleContextMenu = (event: MouseEvent) => {
              if (this.baseUpdateComponent.baseFormGroup.invalid) {
                this.baseUpdateComponent.SaveItem();
                return;
            }
                this.fakDokumentService.checkUnsavedChanges(() => {
                    originalToggleContextMenu(event);  
                });
            };
        } else {
            this.defaultUpdateButtons.ToggleContextMenu = () => {};
        }

      
    }
}
}
